import styles from '../products-add-new-product.module.scss'
import cstyles from './products-skus-section.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { SectionContainer, Checkbox, H2, LabeledLine, Input, Button, Text2, Text1, Select } from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect, useState } from 'react'
import { IconEdit } from 'assets/icons'
import { ProductsSKUsAttributeProduct } from './products-skus-attribute-groups'
import { ProductsSKUsTableProduct } from './products-skus-table'
import { SKUTableActions, SKUTableSortedBy } from 'models'

const ProductsSKUSSectionComponent = (props) => {
    const {
        className,
        style,
        editMode,
        productId
    } = props,
    {
        productsSKUsStore: {
            productSKUsStore,
            setProductSKUsProps,
            updateProductSKUs,
            getProductSKUAttributes,
            hasInitialAttributesAttributes,
            selectedCheckboxesLength,
            selectTableAction,
            setTableSortedBy,
            editSkuByAction,
            tableActionSelected,
            tableSortedBySelected,
            onCancelAction,
            newSkuValueInput,
            setNewValueFromAction,
            clearSelectedCheckboxes
        },
        productsSKUTableStore: {
            skuTableSortedByOptions,
            skuTableActionsOptions,
            skuTableElementsLength,
            handleNewValueActionApply,
            triggerSearch
        }
    } = useRootStore(),

    [editModeSection, setEditModeSection] = useState<boolean>(false),

    [isAttributeCheckboxChecked, setAttributeCheckbox] = useState<boolean>(false),

    onCancelEditClick = (): void => {
        setEditModeSection(false)
    },

    onSaveClick = async () => {
        // TODO-A To trigger an update action
        updateProductSKUs(productId)
        setEditModeSection(false)
    },

    handleAttributeCheckbox = (): void => {
        setAttributeCheckbox(!isAttributeCheckboxChecked);
    },

    onApplyActionChanges = (): void => {
        if(!newSkuValueInput) return
        handleNewValueActionApply(productId)
    }

    useEffect(()=> {
        if(editMode) {
            getProductSKUAttributes(productId)
            triggerSearch({ resetPageNumber: true })
        } 
        if(!editMode) setEditModeSection(true)
        if(hasInitialAttributesAttributes) {
            setAttributeCheckbox(true);
        }
        clearSelectedCheckboxes()
    }, [getProductSKUAttributes, triggerSearch, productId, editMode, hasInitialAttributesAttributes, clearSelectedCheckboxes])

  return (
    <SectionContainer className={cl(className)} style={style} colorPreset='dark' extraPaddingBottom>
        <div className="d-flex justify-content-between">
            <H2 className={styles.sectionHeadingWithButton} colorPreset='dark'>
            Product SKUs
            </H2>
            { editMode && !editModeSection && (
                <Button preset='icon' onClick={() => setEditModeSection(true)}>
                    <IconEdit fill={styles.white} />
                </Button>
            )}
            { editMode && editModeSection && (
                <div className={styles.headingButtonsEditContainer}>
                    <Button
                        preset='secondary'
                        colorPreset='dark'
                        onClick={onCancelEditClick}
                    >
                        Cancel
                    </Button>
                    <Button preset='primary' onClick={onSaveClick}>
                        Save
                    </Button>
                </div>
            )}
        </div>

        { editModeSection && ( 
        <div className="row pt-4">
            <div className="col-lg-6">
                <LabeledLine
                    label='Product SKU'
                    colorPreset='dark'
                >
                    <Input
                    colorPreset='dark'
                    placeholder='Product sku'
                    value={productSKUsStore.sku}
                    onChange={sku => setProductSKUsProps({sku})}
                    />
                </LabeledLine>
                <LabeledLine
                    label='Price'
                    colorPreset='dark'
                >
                    <Input
                    pattern="[0-9]*"
                    colorPreset='dark'
                    placeholder='price'
                    value={productSKUsStore.price}
                    onChange={price => setProductSKUsProps({price: Number(price)})}
                    />
                </LabeledLine>
                <LabeledLine
                    label='Stock'
                    colorPreset='dark'
                >
                    <Input
                    pattern="[0-9]*"
                    colorPreset='dark'
                    placeholder='stock'
                    value={productSKUsStore.stock}
                    onChange={stock => setProductSKUsProps({stock: Number(stock)})}
                    />
                </LabeledLine>
            </div>
        </div>
        )}

        { !editModeSection && ( 
        <div className="row pt-4">
            <div className="col-lg-6">
                <LabeledLine
                    label='Product SKU'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productSKUsStore.sku ? productSKUsStore.sku : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Price'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productSKUsStore.price ? productSKUsStore.price : '-'}
                </Text2>
                </LabeledLine>
                <LabeledLine
                    label='Stock'
                    colorPreset='dark'
                >
                <Text2 colorPreset='dark'>
                    {productSKUsStore.stock ? productSKUsStore.stock : '-'}
                </Text2>
                </LabeledLine>
            </div>
        </div>            
        )}        

        { editMode && !hasInitialAttributesAttributes && (  
            <div className="pt-4 d-flex">
                <Checkbox isChecked={isAttributeCheckboxChecked} onClick={handleAttributeCheckbox} />
                <Text1
                    className={cstyles.checkbox}
                >
                    This product has multiple attributes (ex. different colors, sizes, material)
                </Text1>
            </div>   
        )}

        { editMode && isAttributeCheckboxChecked && (  
            <div className="pt-4">
                <ProductsSKUsAttributeProduct productSKU={productSKUsStore.sku} productId={productId} />
            </div>   
        )}

        { editMode && ( 
            <div className="d-flex justify-content-between pt-4 border-top border-secondary mt-4">
                <div className={cl("d-flex", "align-items-center", cstyles.tableDropdowns)}>
                    <span>{selectedCheckboxesLength}/{skuTableElementsLength}</span>
                        <Select<SKUTableActions>
                            colorPreset='dark'
                            options={skuTableActionsOptions}
                            noNoneOption
                            value={tableActionSelected}
                            placeholder='Actions'
                            className={cl(styles.selectRootClassName, {
                                [cstyles.deactivate] : !selectedCheckboxesLength
                            })}
                            onChange={type =>
                                selectTableAction(type, productId)
                            }
                        /> 
                </div>
                <div className={cl("d-flex", "align-items-center", cstyles.tableDropdowns)}>
                    <span>Show</span>
                    <Select<SKUTableSortedBy>
                        colorPreset='dark'
                        options={skuTableSortedByOptions}
                        noNoneOption
                        value={tableSortedBySelected}
                        placeholder='Actions'
                        className={styles.selectRootClassName}
                        onChange={type =>
                            setTableSortedBy(type)
                        }
                    />
                </div>
            </div>
        )}

        { editMode && editSkuByAction && (
            <div className="d-flex justify-content-between mt-4">
                <div className={cl("d-flex", "align-items-center", cstyles.newValueSection)}>
                    <p>Set a new value</p>
                    <Input
                        colorPreset='dark'
                        placeholder=''
                        value={newSkuValueInput}
                        onChange={value => setNewValueFromAction(value)}
                    />
                </div>
                <div className={styles.headingButtonsEditContainer}>
                    <Button
                        preset='secondary'
                        colorPreset='dark'
                        onClick={onCancelAction}
                    >
                        Cancel
                    </Button>
                    <Button preset='primary' onClick={onApplyActionChanges}>
                        Apply
                    </Button>
                </div>
            </div>
        )}
        
        { editMode && (  
            <div className="pt-4">
                <ProductsSKUsTableProduct productId={productId} />
            </div>   
        )}
    </SectionContainer>
  )
},

ProductsSKUSSectionProduct = observer(ProductsSKUSSectionComponent)
export { ProductsSKUSSectionProduct }
